import { LearningDashboardErrorBoundary } from '@/views/dashboards-learning/dashboards-learning.error';

export default LearningDashboardErrorBoundary;
